function e(e) {
  var r = function r() {
    return {
      get: function get() {},
      set: function set() {}
    };
  };

  return r.keyArea = e, r;
}

export { e as nil };